const CollectionColumn = [
    {
        id: "name",
        label: "Name",
        style: { custom: { flex: 1, pl: 1.5, width: `calc(100% - 54px)` } },
        disabled: true,
        checked: true,
        sortable: true,
        useInAutocomplete: true,
    },
    {
        id: "count",
        label: "Assets Count",
        style: { custom: { width: 54 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
];

const CollectionContentSchemaColumn = [
    {
        id: "desiredStatus",
        label: "status",
        style: { custom: { padding: "0 12px", width: 32 } },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "name",
        label: "Name",
        style: { custom: { flex: 1 } },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "duration",
        label: "Duration",
        style: { custom: { width: 100 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
];

export { CollectionColumn, CollectionContentSchemaColumn };
